/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

// The search results page's tabs and how each maps to the search API, kept from the legacy SearchCtrl.

export type SearchMode = 'query' | 'tag' | 'hashtag';

export interface SearchTab {
  value: string;
  label: string;
}

const TABS: SearchTab[] = [
  { value: 'all', label: 'All' },
  { value: 'articles', label: 'Articles' },
  { value: 'tools', label: 'Tools' },
  { value: 'projects', label: 'Projects' },
  { value: 'users', label: 'Users' },
  { value: 'forums', label: 'Forums' },
];

// The API type for each tab other than All, which uses /search/mixed.
export const TYPE_MAP: Record<string, string> = {
  articles: 'Article',
  tools: 'Tool',
  projects: 'Project',
  users: 'User',
  forums: 'Topic',
};

// Users only for signed-in testers; tags only exist on articles and tools.
export function searchTabs(mode: SearchMode, signedIn: boolean): SearchTab[] {
  return TABS.filter((tab) => (signedIn || tab.value !== 'users')
    && (mode !== 'tag' || ['all', 'articles', 'tools'].includes(tab.value)));
}

// A type the route doesn't offer (courses, Users while signed out, Forums on a tag) shows All, as before.
export function resolveTab(contentType: string | undefined, tabs: SearchTab[]): string {
  return tabs.some((tab) => tab.value === contentType) ? contentType : 'all';
}
